<template>
  <div>
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <div class="info-field">
          <q-icon name="task_alt" size="20px" color="primary" class="field-icon" />
          <span class="info-label">Задача:</span>
          <span class="info-value">{{ this.data?.task_name || '-' }}</span>
        </div>
      </div>
      <!-- План (оригинал) - только для чтения -->
      <div v-if="this.data?.plan_orig_value !== null && this.data?.plan_orig_value !== undefined" class="form__item">
        <div class="info-field readonly-field">
          <q-icon name="calendar_today" size="18px" color="grey-7" class="field-icon" />
          <span class="info-label">План (оригинал):</span>
          <span class="info-value">{{ this.data?.plan_orig_value || '0' }}</span>
        </div>
      </div>

      <!-- Факт (оригинал) - редактируемое -->
      <div class="form__item">
        <CustomInput
          label="Факт (оригинал)"
          type="number"
          :value="this.formData.fact_orig_value"
          @change_input="(value) => onChange('fact_orig_value', value)"
          placeholder="Введите значение"
          class="fact-input"
        />
      </div>

      <!-- Причина отставания - показываем только если факт меньше плана -->
      <div v-if="shouldShowReason" class="form__item">
        <CustomSelect
          label="Причина отставания"
          :value="this.formData.reason_id"
          @change="(value) => onChange('reason_id', value)"
          :options="this.reasons"
          optionValueKey="reason_id"
          optionLabelKey="reason_name"
          :loading="this.reasonsLoading"
          placeholder="Выберите причину"
        />
      </div>

      <div class="form__footer">
        <div v-if="this.data?.work_task_fact_id" class="delete-btn-container">
          <q-btn
            label="Удалить"
            color="negative"
            outline
            :loading="this.loading"
            @click="onDelete"
            class="delete-btn"
          />
        </div>
        <CustomModalFooter :btn-loading="this.loading" />
      </div>
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getReasons } from "@/views/TierFactFirst/services";

export default {
  name: "edit-tier-fact-timeline",
  components: { CustomInput, CustomSelect, CustomModalFooter },
  props: ['data'],
  data() {
    return {
      loading: false,
      reasons: [],
      reasonsLoading: false,
      formData: {
        fact_orig_value: this.data?.fact_orig_value || '',
        reason_id: null, // Устанавливаем после загрузки причин
      }
    }
  },
  computed: {
    // План на этот день (из work_task_plan_tab)
    planValue() {
      return parseFloat(this.data?.plan_value ?? this.data?.plan_orig_value ?? 0) || 0;
    },
    // Введённый факт (оригинал); пустое считаем 0
    factValue() {
      const rawFact = this.formData.fact_orig_value;
      const fact = rawFact === null || rawFact === undefined || rawFact === ''
        ? 0
        : parseFloat(rawFact) || 0;
      return fact;
    },
    // Причину запрашивать ТОЛЬКО когда есть план на этот день и введённый факт меньше плана.
    // Долг с предыдущих дней не должен требовать причину (причина фиксируется в день возникновения отставания).
    shouldShowReason() {
      return this.planValue > 0 && (this.factValue + 1e-9 < this.planValue);
    }
  },
  async mounted() {
    await this.loadReasons();
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    formatDate(date) {
      if (!date) return '-';
      // Преобразуем YYYY-MM-DD в DD.MM.YYYY
      const parts = date.split('-');
      if (parts.length === 3) {
        return `${parts[2]}.${parts[1]}.${parts[0]}`;
      }
      return date;
    },
    async loadReasons() {
      this.reasonsLoading = true;
      try {
        const reasonsData = await getReasons();
        console.log('Loaded reasons:', reasonsData);
        console.log('Modal data.reason_id:', this.data?.reason_id);
        
        // Убеждаемся, что reason_id в options - это числа
        this.reasons = reasonsData.map(reason => ({
          ...reason,
          reason_id: parseInt(reason.reason_id) || reason.reason_id
        }));
        
        // После загрузки причин устанавливаем reason_id, если он есть в data
        // Используем $nextTick чтобы убедиться, что список причин уже отрендерен
        await this.$nextTick();
        if (this.data?.reason_id && this.reasons.length > 0) {
          const reasonId = parseInt(this.data.reason_id);
          console.log('Parsed reasonId:', reasonId);
          if (reasonId && !isNaN(reasonId)) {
            // Проверяем, что такая причина существует в списке
            const reasonExists = this.reasons.some(r => r.reason_id === reasonId);
            console.log('Reason exists:', reasonExists);
            if (reasonExists) {
              this.formData.reason_id = reasonId;
              console.log('Set formData.reason_id to:', reasonId);
            }
          }
        }
      } catch (e) {
        console.error('Error loading reasons:', e);
        this.reasons = [];
      } finally {
        this.reasonsLoading = false;
      }
    },
    async onSubmit() {
      this.loading = true
      // Передаем данные для обновления work_task_fact_tab
      // Если есть долг, причина обязательна
      if (this.shouldShowReason && (!this.formData.reason_id || this.formData.reason_id === '')) {
        this.loading = false
        alert('На этот день остается долг. Укажите, пожалуйста, причину отставания.')
        return
      }

      const factValue =
        this.formData.fact_orig_value === null ||
        this.formData.fact_orig_value === undefined ||
        this.formData.fact_orig_value === ''
          ? 0
          : this.formData.fact_orig_value

      const submitData = {
        fact_orig_value: factValue,
        work_task_fact_id: this.data?.work_task_fact_id || null,
        work_group_id: this.data?.work_group_id,
        task_dict_id: this.data?.task_dict_id,
        fact_date: this.data?.fact_date,
        work_group_level_id: this.data?.work_group_level_id || null,
        reason_id: this.shouldShowReason ? (this.formData.reason_id || null) : null,
      }
      await this.data?.onSubmit(submitData)
      this.loading = false
    },
    async onDelete() {
      this.loading = true
      const deleteData = {
        work_task_fact_id: this.data?.work_task_fact_id,
      }
      await this.data?.onDelete(deleteData)
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 320px;
  gap: 8px;
  margin-top: 5px;

  @media (max-width: 428px) {
    width: 100%;
  }
}

.form__item {
  margin-bottom: 0;
}

.info-field {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 4px;
  
  &.readonly-field {
    background: #fafafa;
  }
}

.field-icon {
  flex-shrink: 0;
}

.info-label {
  font-weight: 500;
  color: #666;
  white-space: nowrap;
}

.info-value {
  color: #333;
  flex: 1;
  word-break: break-word;
}

.form__section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e0e0e0;
  
  &.original-values {
    background: #f9f9f9;
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 12px;
  }
}

.form__footer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.delete-btn-container {
  display: flex;
  justify-content: flex-start;
  padding-top: 6px;
  border-top: 1px solid #e0e0e0;
}

.delete-btn {
  min-width: 100px;
}
</style>

